import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import "jspdf-autotable";
import Dropzone from 'react-dropzone-uploader';
import { Base64 } from 'js-base64';
import {
  getSliders as onGetSliders,
  addSlider as onAddSlider,
  updateSlider as onUpdateSlider,
  deleteSlider as onDeleteSlider,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
//redux
import { useSelector, useDispatch } from "react-redux";
import { NameSurname } from "./contactlistCol";

const ContactsList = props => {
  const tableRef = useRef(null);

  //meta title
  document.title = "Gramer | Bee Education PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();

  const [getFileName, setFileName] = useState(null);


  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {

      title: (contactEdit && contactEdit.title) || "",
      explanation: (contactEdit && contactEdit.explanation) || ""

    },
    validationSchema: Yup.object({


    }),
    onSubmit: values => {
      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          title:values.title,
         explanation: values.explanation,
         Qustion_Type_ID : getCategoryID
        };
        dispatch(onUpdateSlider(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          title:values["explanation"],
          explanation:values["explanation"],
          Qustion_Type_ID : getCategoryID
        };
        // save new user
        dispatch(onAddSlider(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.sliders,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [isEdit, setIsEdit] = useState(false);

  const [getCategoryID, setCategoryID] = useState(null);
  const [getCategory, setCategory] = useState([]);

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "Başlık",
        accessor: "title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },


      {
        Header: "Kategori",
        accessor: "Question_Type.Question_Type_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },


      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">

             
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

useEffect(() => {
  const fetchCategory = async () => {
    try {
      const res = await axios.get(`https://beeducationadmin.stechomeyazilim.info:8093/getQuestionTypeBee/select/`);
      setCategory(res.data);
    } catch (error) {
      console.error("Veri çekilirken bir hata oluştu:", error);
    }
  };

  fetchCategory();
}, []); // <-- Bağımlılık dizisi boş

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetSliders());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
    // setIsEdit(false);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      //setIsEdit(false);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };



  const handleUserClick = (arg) => {
    const user = arg;

    setEditContact(user);

    setCategoryID(user.Qustion_Type_ID)


    setIsEdit(true);


    toggle();
  };

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteSlider(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };


  const _setChoiceSubCategory = arg => {
    setCategoryID(arg.target.value)
  }


  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Gramer Listesi" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={users}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddSlider={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                 

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Gramer Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>




                            <div className="mb-3">
                              <Label className="form-label">Başlık</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Başlık Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>


<div className="mb-3">
  <Label className="form-label">Açıklama</Label>
  <Input
    name="explanation"
    label="explanation"
    // Değişiklik burada
    type="textarea"
    // İsteğe bağlı: Başlangıç yüksekliğini 5 satır olarak ayarlar
    rows="5" 
    placeholder="Açıklama Giriniz"
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    value={validation.values.explanation || ""}
    invalid={
      validation.touched.explanation &&
      validation.errors.explanation
        ? true
        : false
    }
  />
  {validation.touched.explanation &&
    validation.errors.explanation ? (
    <FormFeedback type="invalid">
      {validation.errors.explanation}
    </FormFeedback>
  ) : null}
</div>
                  
                          </Col>
                        </Row>

                             <Row>
                                                  <Col xs={12}>
                                                  <div className="mb-3">
                                                                             <Label className="form-label">Ders Seçiniz</Label>
                                                                             <Input
                                                                               name="getSubCategoryID"
                                                                               type="select"
                                                                               className="form-select"
                                                                               defaultValue={getCategoryID}
                                                                               onChange={(text) => _setChoiceSubCategory(text)}
                                                                               value={
                                                                                 getCategoryID
                                                                               }>
                                                                                <option value="">Lütfen Seçim Yapınız</option>
                                                                               {getCategory.map((item, index) => (
                                                                                 <option value={item.ID} key={item.ID}>{item.Question_Type_Title}</option>
                                                                               ))}
                                               
                                                                             </Input>
                                                                            
                                                                           </div>

                                           
                                                  </Col>
                                                </Row>

                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
